module.exports = __webpack_public_path__ + "static/media/haiwaineimaocaigouliucheng.38cf2b1d.png";